import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tp-grid-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_teaching_plan_cell = _resolveComponent("teaching-plan-cell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tp-grid",
      style: _normalizeStyle({ zoom: String(_ctx.zoom / 100) })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.rows, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rowIndex,
          class: "tp-grid__row"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, (cell, cellIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${rowIndex}-${cellIndex}`,
              class: "tp-grid__col",
              style: _normalizeStyle({ width: `${_ctx.widthPercents(row.widths)[cellIndex]}%` })
            }, [
              _createVNode(_component_teaching_plan_cell, {
                ref_for: true,
                ref: _ctx.cellRefName(cell),
                cell: cell,
                value: _ctx.valueOf(cell),
                reference: _ctx.referenceOf(cell),
                editable: _ctx.editable,
                selected: _ctx.selectedItemKey !== null && _ctx.selectedItemKey === cell.itemKey,
                "comment-count": _ctx.commentCountOf(cell),
                transfer: _ctx.transferOf(cell),
                onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', $event))),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event))),
                onJumpSource: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('jump-source', $event))),
                onTransferCell: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('transfer-cell', $event)))
              }, null, 8, ["cell", "value", "reference", "editable", "selected", "comment-count", "transfer"])
            ], 4))
          }), 128))
        ]))
      }), 128))
    ], 4)
  ]))
}